// extracted by mini-css-extract-plugin
export var breadcrumb = "_j-0";
export var breadcrumbArrow = "_j-1";